import { render, staticRenderFns } from "./invoice_billList.vue?vue&type=template&id=2bc3f72a"
import script from "./invoice_billList.vue?vue&type=script&lang=js"
export * from "./invoice_billList.vue?vue&type=script&lang=js"
import style0 from "./invoice_billList.vue?vue&type=style&index=0&id=2bc3f72a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports